import { BaseCommand } from './BaseCommand.js';
import { createServer, ViteDevServer } from 'vite';
import { createViteConfig } from '../config/ViteConfig.js';

export interface DevOptions {
	port?: string;
	host?: string;
	open?: boolean;
}

export class DevCommand extends BaseCommand {
	private server: ViteDevServer | null = null;

	async execute(options: DevOptions): Promise<void> {
		try {
			console.log('[Frame] Starting development server...');

			// Create Vite configuration
			const viteConfig = await createViteConfig(this.cwd);

			// Override with command line options
			if (options.port) {
				viteConfig.server = viteConfig.server || {};
				viteConfig.server.port = parseInt(options.port);
			}

			if (options.host) {
				viteConfig.server = viteConfig.server || {};
				viteConfig.server.host = options.host;
			}

			if (options.open) {
				viteConfig.server = viteConfig.server || {};
				viteConfig.server.open = true;
			}

			// Create and start the development server
			this.server = await createServer(viteConfig);
			await this.server.listen();

			// Print server info
			this.server.printUrls();
			console.log('[Frame] Development server started!');

			// Handle graceful shutdown
			process.on('SIGINT', () => this.shutdown());
			process.on('SIGTERM', () => this.shutdown());

		} catch (error) {
			const errorMessage = error instanceof Error ? error.message : String(error);
			this.logError(`Failed to start development server: ${errorMessage}`);
			process.exit(1);
		}
	}

	private async shutdown(): Promise<void> {
		if (this.server) {
			await this.server.close();
			console.log('\n[Frame] Development server stopped');
		}
		process.exit(0);
	}
} 